'use client';

import { Divider } from '@bgzt/ui';

import { ProductDetail } from '~/app/products/[pid]/_queries/product-detail-options';

import { Section, Spacing } from '~/components';
import { ProductInfo, NoticeCard, ProductDescriptionGroup } from '~/app/products/[pid]/_components/Info';
import {
  RecommendProducts,
  CategoryProducts,
  ProductShopEntryBanner,
  ShopMoreProducts,
} from '~/app/products/[pid]/_components';

import { useQuery } from '@tanstack/react-query';

import { ProductDataV2 } from '~/apis/search';
import { getConditionStatus } from '~/utils';
import { ShopId } from '~/constants/shop';
import {
  defaultRecommendProductsQueryOptions,
  defaultSearchCategoryProductsQueryOptions,
  defaultSearchShopProductsQueryOptions,
} from '../../_utils';
type Props = {
  product: ProductDetail['product'];
  shop?: ProductDetail['shop'];
};

export const Info = ({ product, shop }: Props) => {
  // react-queries
  const { data: shopProducts } = useQuery(defaultSearchShopProductsQueryOptions(shop?.shopId as string));
  const { data: recommendProducts } = useQuery(defaultRecommendProductsQueryOptions(product.pid));
  const { data: categoryProducts } = useQuery(
    defaultSearchCategoryProductsQueryOptions(product.category.id, product.pid),
  );

  return (
    <>
      <Spacing height={30} />
      <Section>
        <ProductInfo
          values={{
            brand: product?.brand ?? null,
            categories: product?.categories ?? null,
            condition: getConditionStatus(product?.condition),
            size: product?.size ?? null,
            qty: product?.qty ?? null,
          }}
        />
      </Section>

      {shop && (
        <Section>
          <Spacing height={20} />
          <ProductShopEntryBanner shopId={shop.shopId} />
        </Section>
      )}

      <Spacing height={30} />
      <Section>
        <ProductDescriptionGroup pid={product?.pid} translatedDescription={product?.description} />

        <Spacing height={30} />

        <NoticeCard shopId={shop?.shopId as ShopId} />

        <Spacing height={30} />
      </Section>

      <Divider thickness={10} />

      <Section>
        <ShopMoreProducts shopId={shop?.shopId} shopProducts={shopProducts as ProductDataV2[]} />
      </Section>
      <Section>
        <RecommendProducts pid={product.pid} recommendProducts={recommendProducts} />
      </Section>
      <Section>
        <CategoryProducts
          pid={product.pid}
          categoryName={product.categories[0]?.name}
          categoryProducts={categoryProducts as ProductDataV2[]}
        />
        <Spacing height={40} />
      </Section>
    </>
  );
};
